import React from 'react'
import UpdateExpenseFlyout from 'src/app/UpdateExpenseFlyout/UpdateExpenseFlyout'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateExpenseRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateExpenseAppRoute: AppRoute = {
  id: AppLocation.UpdateExpense,
  routeProps: updateExpenseRouteProps,
  component: <UpdateExpenseFlyout />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateExpenseAppRoute
